import { faDoorOpen, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Card, CardBody, CardTitle } from 'reactstrap';

import { AutoFocusHeader } from '../../../_components/auto-focus-header';
import { Button } from '../../../_components/button';
import { parseTextWithURL } from '../../../_components/parse-text-with-url';

export interface SubmissionResult {
  error?: string;
}

export function RetryExpired() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const error = state?.error || 'Error: Please contact your administrator';
  return (
    <Container className="py-4 text-center" fluid>
      <div className="mx-auto my-5 col-md-9 col-lg-9">
        <Card className="shadow-sm pb-3 mx-auto">
          <CardBody className="pb-0" role="main">
            <>
              <CardTitle>
                <AutoFocusHeader className="mt-0 mt-sm-3 mb-3 mb-sm-5">
                  Submission Failed
                </AutoFocusHeader>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  size="8x"
                  className="text-red mb-1 mb-sm-5"
                />
              </CardTitle>
              <div className="d-flex justify-content-center">
                <p style={{ maxWidth: '700px' }}>{parseTextWithURL(error)}</p>
              </div>

              <div className="d-flex justify-content-center fw-bold">
                <p style={{ maxWidth: '700px' }}>
                  You are out of retries. Your session is now expired. Please
                  click the Sign Out button below to return to the sign in page.
                </p>
              </div>
            </>
          </CardBody>
          <hr aria-hidden="true" />
          <Container>
            <Button
              aria-description="Press Enter to sign out"
              color="primary"
              onClick={async () => {
                navigate('/compliance');
              }}
            >
              Sign Out
              <FontAwesomeIcon icon={faDoorOpen} className="ms-2" />
            </Button>
          </Container>
        </Card>
      </div>
    </Container>
  );
}
